import Vue from 'vue';
import Dropzone from 'dropzone';

Vue.component('file-upload-component', {
    props: {
        errors: {
            default: () => [],
        },

        acceptedFiles: {
            type: String,
            default: '',
        },

        uploadPath: {
            type: String,
            default: '',
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            dropzoneEl: null,
            dropzone: null,
            uploadedFile: null,
            uploadError: false,
            uploadProcessing: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.dropzoneEl = this.$el.querySelector('#dropzone');

        this.dropzone = new Dropzone(this.dropzoneEl, {
            url: this.uploadPath,
            acceptedFiles: this.acceptedFiles,
            maxFiles: 1,
            createImageThumbnails: false,
        });

        this.dropzone.on('sending', (file, xhr, formData) => {
            formData.append(window.csrfTokenName, window.csrfTokenValue);
        });

        this.dropzone.on('addedfile', () => {
            this.uploadProcessing = true;
            this.uploadError = false;
        });

        this.dropzone.on('complete', (file) => {
            this.uploadProcessing = false;
            const parsedResponse = JSON.parse(file.xhr.response);

            if (!parsedResponse.data) {
                return;
            }

            this.uploadedFile = file;
            this.$emit('filechange', parsedResponse.data.uid);
        });

        this.dropzone.on('error', (file, error) => {
            if (error) {
                this.uploadError = true;
                this.uploadedFile = null;
            }
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        removeFile() {
            this.dropzone.removeFile(this.uploadedFile);
            this.uploadedFile = null;
        },
    },
});
